import axios from 'axios'
import React, { Component } from 'react'

import Error from './Error'
import SingleSide from './SingleSide'

import './axios-news.css'

class AxiosNews extends Component {
  constructor(props) {
    super(props)
    this.state = {
      news: [],
      loading: true,
      error: false,
    }
  }

  componentDidMount() {
    const urlStart = 'http://newsapi.org/v2/'
    const urlKey = 'df92ca02d82d4a62be5dc021a4c479b5'
    const url = `${urlStart}${this.props.type}?country=${this.props.country}&category=${this.props.category}&apiKey=${urlKey}`
    console.log(url)

    // axios.post(url, {data: {news: {title:"",description:""}}})

    axios
      .get(url)
      .then((response) => {
        this.setState({
          news: response.data.articles,
          error: false,
          loading: false,
        })
      })
      .catch((error) => this.setState({ error: true }))
  }

  renderItems() {
    return this.state.news.map((item) => (
      <SingleSide key={item.url} item={item} />
    ))
  }

  render() {
    return (
      <div className="row grid-news">
        {this.state.error ? (
          <Error />
        ) : this.state.loading ? (
          <h3>Loading News...</h3>
        ) : (
          this.renderItems()
        )}
      </div>
    )
  }
}

export default AxiosNews
